export default __webpack_public_path__ + "static/media/clp.4f0f4170.mp3";